var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { backlog_actions } from '../actions/backlog_actions';
var buildDefaultFilterSnapshot = function () { return ({
    selectedVendor: { Id: 'All', Name: 'All' },
    selectedStatus: { label: '', value: null },
    selectedSavedFilter: '',
    selectedUniqueStatus: [],
    searchText: '',
    globalSearchText: '',
    selectedPrograms: [],
    currentPage: 1,
    perPageCount: 50,
    sortBy: '',
    sortOrder: 'ASC',
    selectedSalesRep: [],
    selectedDealers: [],
    selectedForecastDataRange: { StartDate: '', EndDate: '' },
}); };
var initialState = {
    selectedVendor: { Id: 'All', Name: 'All' },
    selectedStatus: { label: '', value: null },
    selectedSavedFilter: '',
    selectedUniqueStatus: [],
    searchText: '',
    globalSearchText: '',
    selectedPrograms: [],
    currentPage: 1,
    perPageCount: 50,
    sortBy: '',
    sortOrder: 'ASC',
    reduxMainResp: null,
    reduxAppResp: null,
    selectedSalesRep: [],
    selectedDealers: [],
    selectedForecastDataRange: { StartDate: '', EndDate: '' },
    activeTab: 0,
    backlogQueueSnapshot: buildDefaultFilterSnapshot(),
    allDealsSnapshot: buildDefaultFilterSnapshot(),
    visibleColumnKeys: [],
};
var FILTER_KEYS = [
    'selectedVendor',
    'selectedStatus',
    'selectedSavedFilter',
    'searchText',
    'globalSearchText',
    'selectedPrograms',
    'currentPage',
    'perPageCount',
    'selectedUniqueStatus',
    'sortBy',
    'sortOrder',
    'selectedSalesRep',
    'selectedDealers',
    'selectedForecastDataRange',
];
var cloneDefaultSnapshot = function () { return buildDefaultFilterSnapshot(); };
var extractFilterPayload = function (payload) {
    var nextPayload = {};
    FILTER_KEYS.forEach(function (key) {
        if (payload && Object.prototype.hasOwnProperty.call(payload, key)) {
            nextPayload[key] = payload[key];
        }
    });
    return nextPayload;
};
var extractNonFilterPayload = function (payload) {
    if (!payload || typeof payload !== 'object') {
        return {};
    }
    var nextPayload = {};
    Object.keys(payload).forEach(function (key) {
        if (key === 'activeTab') {
            return;
        }
        if (!FILTER_KEYS.includes(key)) {
            nextPayload[key] = payload[key];
        }
    });
    return nextPayload;
};
var syncFlatStateFromSnapshot = function (state, snapshot) { return (__assign(__assign({}, state), { selectedVendor: snapshot.selectedVendor, selectedStatus: snapshot.selectedStatus, selectedSavedFilter: snapshot.selectedSavedFilter, selectedUniqueStatus: snapshot.selectedUniqueStatus, searchText: snapshot.searchText, globalSearchText: snapshot.globalSearchText, selectedPrograms: snapshot.selectedPrograms, currentPage: snapshot.currentPage, perPageCount: snapshot.perPageCount, sortBy: snapshot.sortBy, sortOrder: snapshot.sortOrder, selectedSalesRep: snapshot.selectedSalesRep, selectedDealers: snapshot.selectedDealers, selectedForecastDataRange: snapshot.selectedForecastDataRange })); };
export function BacklogReducerFunc(state, _a) {
    var _b;
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case backlog_actions.Constants.UpdateFilterState:
            {
                var filterPayload = extractFilterPayload(payload);
                var nonFilterPayload = extractNonFilterPayload(payload);
                var nextActiveTab = typeof (payload === null || payload === void 0 ? void 0 : payload.activeTab) === 'number' ? payload.activeTab : state.activeTab;
                var targetSnapshotKey = nextActiveTab === 1 ? 'allDealsSnapshot' : 'backlogQueueSnapshot';
                var nextSnapshot = __assign(__assign({}, state[targetSnapshotKey]), filterPayload);
                return syncFlatStateFromSnapshot(__assign(__assign(__assign(__assign({}, state), nonFilterPayload), (typeof (payload === null || payload === void 0 ? void 0 : payload.activeTab) === 'number' ? { activeTab: payload.activeTab } : {})), (_b = {}, _b[targetSnapshotKey] = nextSnapshot, _b)), nextSnapshot);
            }
        case backlog_actions.Constants.SetActiveTab: {
            var nextActiveTab = payload === 1 ? 1 : 0;
            var snapshot = nextActiveTab === 1 ? state.allDealsSnapshot : state.backlogQueueSnapshot;
            return syncFlatStateFromSnapshot(__assign(__assign({}, state), { activeTab: nextActiveTab }), snapshot);
        }
        case backlog_actions.Constants.ResetCurrentTabFilters: {
            var defaultSnapshot = cloneDefaultSnapshot();
            if (state.activeTab === 1) {
                return syncFlatStateFromSnapshot(__assign(__assign({}, state), { allDealsSnapshot: defaultSnapshot }), defaultSnapshot);
            }
            return syncFlatStateFromSnapshot(__assign(__assign({}, state), { backlogQueueSnapshot: defaultSnapshot }), defaultSnapshot);
        }
        case backlog_actions.Constants.ResetAllDealsFilters: {
            var defaultSnapshot = cloneDefaultSnapshot();
            return __assign(__assign({}, state), { allDealsSnapshot: defaultSnapshot });
        }
        case backlog_actions.Constants.SetVisibleColumns:
            return __assign(__assign({}, state), { visibleColumnKeys: Array.isArray(payload) ? payload : state.visibleColumnKeys });
        case backlog_actions.Constants.ResetFilterState:
            return __assign({}, initialState);
        default:
            return state;
    }
}
var BacklogReducer = function () {
    return React.createElement(Outlet, null);
};
export default BacklogReducer;
